import { Group } from '@components/layout';
import { Typography } from '@components/typography';
import { SxProps } from '@mui/material';
import { PropsWithChildren } from 'react';

export const LandingPageHeader = ({
  children,
  sx,
  title,
}: PropsWithChildren<{ title?: string; sx?: SxProps }>) => (
  <Group mb={5} sx={{ justifyContent: 'space-between', ...sx }}>
    {title && (
      <Typography maxWidth="400px" variant="h1" noWrap handleOverFlow>
        {title}
      </Typography>
    )}
    {children}
  </Group>
);
